/* global axios */

const DEFAULT_API_VERSION = 'v1';

const normalizeAccountId = accountId => {
  if (accountId === undefined || accountId === null) {
    throw new TypeError('accountId is required');
  }

  if (typeof accountId === 'number') {
    if (!Number.isSafeInteger(accountId) || accountId <= 0) {
      throw new TypeError('accountId must be a positive integer');
    }
    return String(accountId);
  }

  if (typeof accountId !== 'string') {
    throw new TypeError('accountId must be a positive integer');
  }

  const normalizedAccountId = accountId.trim();
  if (!normalizedAccountId) {
    throw new TypeError('accountId is required');
  }
  if (!/^[1-9]\d*$/.test(normalizedAccountId)) {
    throw new TypeError('accountId must be a positive integer');
  }

  return normalizedAccountId;
};

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  urlForAccount(accountId) {
    const normalizedAccountId = normalizeAccountId(accountId);

    return `${this.apiVersion}/accounts/${normalizedAccountId}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.enterprise) {
      url = `/enterprise${url}`;
    }

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  getForAccount(accountId, config) {
    const requestUrl = this.urlForAccount(accountId);
    return config === undefined
      ? axios.get(requestUrl)
      : axios.get(requestUrl, config);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
